var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarGrouphistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M4 9.95495V5C4 3.34315 5.34315 2 7 2H17C18.6568 2 20 3.34315 20 5V9.95495C20 10.6097 19.6819 11.2218 19.1343 11.5806C17.4417 12.6896 13.71 15 12 15C10.29 15 6.55835 12.6896 4.86571 11.5806C4.31808 11.2218 4 10.6097 4 9.95495Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99902 6.251C3.48952 6.62919 3.03925 6.97507 2.67796 7.2576C2.07597 7.72835 1.69861 8.4226 1.64768 9.1851C1.57839 10.2227 1.49902 11.9645 1.49902 14.5C1.49902 16.8978 1.64098 18.5858 1.77362 19.6396C1.88298 20.5085 2.46471 21.1975 3.32241 21.3746C4.69765 21.6585 7.32372 22 11.999 22C16.6743 22 19.3004 21.6585 20.6756 21.3746C21.5333 21.1975 22.1151 20.5085 22.2244 19.6396C22.3571 18.5858 22.499 16.8978 22.499 14.5C22.499 11.9645 22.4197 10.2227 22.3504 9.1851C22.2994 8.4226 21.9221 7.72835 21.3201 7.2576C20.9588 6.97507 20.5085 6.62919 19.999 6.251V9.95495C19.999 10.6097 19.6809 11.2218 19.1333 11.5806C17.4407 12.6896 13.709 15 11.999 15C10.289 15 6.55737 12.6896 4.86473 11.5806C4.3171 11.2218 3.99902 10.6097 3.99902 9.95495V6.251Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 5.75C6.99902 5.3358 7.33482 5 7.74902 5H12.249C12.6632 5 12.999 5.3358 12.999 5.75C12.999 6.1642 12.6632 6.5 12.249 6.5H7.74902C7.33482 6.5 6.99902 6.1642 6.99902 5.75Z",
    fill: "#637381"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 9.25C6.99902 8.8358 7.33482 8.5 7.74902 8.5H15.249C15.6632 8.5 15.999 8.8358 15.999 9.25C15.999 9.6642 15.6632 10 15.249 10H7.74902C7.33482 10 6.99902 9.6642 6.99902 9.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGrouphistory);
export default __webpack_public_path__ + "static/media/sidebar_grouphistory.8f8dfb4791db1357a802c26506f127d9.svg";
export { ForwardRef as ReactComponent };